module.exports = __webpack_public_path__ + "img/en.ce5a2bd9.png";